import DataTableInit from './datatable.js';

$(document).ready(function() {
    if($('.user-data-table').length) {

        var dataTable = $('.user-data-table').DataTable({
            processing: true,
            serverSide: true,
            language : {
                sLengthMenu: "Show _MENU_",
                emptyTable: "User currently has no visits"
            },
            ajax: window.site.userHistoryTableData,
            columns: [
                // { data: 'action', name: 'action', orderable: false, searchable: false, className: 'select-checkbox checkbox-td', targets: 0 },
                { data: 'id', name: 'visits.id' },
                { data: 'company_name', name: 'company.company_name' },
                { data: 'visit_date', name: 'visits.visit_date' },
                { data: 'method_name', name: 'sign_in_method.method_name' },
            ],
            "fnDrawCallback":function(){
                DataTableInit.handlePaginationState();
                DataTableInit.addDropdownArrows();
                DataTableInit.makeRowsClickable();
                DataTableInit.addDropdownArrowsSelectbox();
            },
            "fnInitComplete":function() {
                DataTableInit.addSearchCross();
                DataTableInit.makeRowsClickable();
            },
            'createdRow': function( row, data, dataIndex ) {
                $(row).attr('data-href', window.site.url + '/visit/' + data.id);
            }
        });

        DataTableInit.construct(dataTable, true);

        dataTable.order( [[ 3, 'desc']] ).draw();

    }
});


// WEBPACK FOOTER //
// ./user-history-datatable.js